<template>
  <div class="policy-page">
    <h1>Terms and Conditions</h1>
    <div class="policy-content">
      <p class="last-updated">Last updated: 6 May 2025</p>
      <p>By using our platform, you agree to the following Terms and Conditions:</p>
      <section>
        <h2>Use of the site</h2>
        <ul>
          <li>You agree to use this website lawfully and respectfully</li>
          <li>We reserve the right to update or modify products, prices, and site features at any time</li>
        </ul>
      </section>
      <section>
        <h2>Products</h2>
        <ul>
          <li>All items listed are archive or second-hand pieces and may show signs of wear</li>
          <li>While we do our best to provide accurate photos and descriptions, availability is not guaranteed until your order is confirmed</li>
        </ul>
      </section>
      <section>
        <h2>Payments and pricing</h2>
        <ul>
          <li>All listed prices include our service fee for sourcing, verification, and logistics</li>
          <li>Payments are handled securely via trusted third-party providers</li>
        </ul>
      </section>
      <section>
        <h2>Limitation of liability</h2>
        <ul>
          <li>We are not responsible for external shipping delays or issues outside of our control</li>
          <li>Some pieces are displayed in real time and may become unavailable without notice</li>
        </ul>
      </section>
      <section>
        <h2>Contact</h2>
        <p>For any questions or assistance, please email: <a href="mailto:info@curatoreden.com">info@curatoreden.com</a></p>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Terms'
}
</script>

<style scoped>
.policy-page {
  max-width: 800px;
  margin: 0 auto;
  padding: 40px 20px;
}

h1 {
  font-size: 2.5rem;
  margin-bottom: 24px;
  color: #333;
}

.last-updated {
  font-size: 1rem;
  color: #444;
  margin-bottom: 1.5rem;
}

.policy-content {
  line-height: 1.6;
}

section {
  margin-bottom: 24px;
}

h2 {
  font-size: 1.2rem;
  color: #444;
  margin-bottom: 10px;
}

ul {
  margin-left: 1.5rem;
  margin-bottom: 1rem;
}

li {
  margin-bottom: 0.5rem;
  color: #666;
  font-size: 1rem;
}

p {
  color: #666;
  margin-bottom: 15px;
}

a {
  color: #007bff;
  text-decoration: underline;
}

@media (max-width: 768px) {
  .policy-page {
    padding: 20px;
  }
  h1 {
    font-size: 2rem;
    margin-bottom: 18px;
  }
  h2 {
    font-size: 1.05rem;
  }
}
</style> 